import type { PropsWithoutRef, SVGProps } from "react";
import { cn } from "@/lib/utils";

const CAMERA_FILL = "var(--color-brand-primary)";

export default function CameraCircle({ className, ...props }: PropsWithoutRef<SVGProps<SVGElement>>) {
	return (
		<svg
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={cn(className)}
			{...props}
		>
			<circle cx="16.5" cy="16.5" r="15.5" fill={CAMERA_FILL} strokeWidth="2" />
			<path
				d="M25.728 12.2159V21.5374C25.728 22.3951 24.953 23.0909 23.9979 23.0909H9.00355C8.04838 23.0909 7.27344 22.3951 7.27344 21.5374V12.2159C7.27344 11.3582 8.04838 10.6624 9.00355 10.6624H12.1754L12.6188 9.59753C12.8711 8.99228 13.5163 8.59094 14.2371 8.59094H18.7607C19.4816 8.59094 20.1267 8.99228 20.3791 9.59753L20.826 10.6624H23.9979C24.953 10.6624 25.728 11.3582 25.728 12.2159ZM20.826 16.8767C20.826 14.734 18.8868 12.9927 16.5007 12.9927C14.1146 12.9927 12.1754 14.734 12.1754 16.8767C12.1754 19.0193 14.1146 20.7606 16.5007 20.7606C18.8868 20.7606 20.826 19.0193 20.826 16.8767ZM19.6726 16.8767C19.6726 18.4464 18.2488 19.7249 16.5007 19.7249C14.7526 19.7249 13.3288 18.4464 13.3288 16.8767C13.3288 15.3069 14.7526 14.0284 16.5007 14.0284C18.2488 14.0284 19.6726 15.3069 19.6726 16.8767Z"
				className="fill-white dark:fill-foreground"
			/>
		</svg>
	);
}
